import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { createProject } from "../../../redux/store/actions/projectActions";
import Chip from '@material-ui/core/Chip';


class CrearProyectoModal extends Component {
  state = {
    title: "",
    color: "",
    miembros: "",

  };
  handleChange = e => {
    console.log(e.target.id, ": ", e.target.value);
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    // console.log(this.state);
    this.props.createProject(this.state);
    this.props.onCloseModal();
  };

  render() {
    const { onCloseModal } = this.props;
    return (
      <Fragment>
        <div className="center-align" style={{ width: "750px" }}>
          <h5
            className="white-text indigo accent-4"
            style={{ padding: "50px" }}
          >
            Nuevo proyecto
          </h5>
        </div>

        <form
          onSubmit={this.handleSubmit}
          className="white"
          style={{ padding: "0" }}
        >
          <div className="row">
            <div className="col s5">
              <p>Nuevo Proyecto</p>
              <div className="input-field">
                <label htmlFor="title">Nombre Proyecto *</label>
                <input
                  required
                  type="text"
                  id="title"
                  onChange={this.handleChange}
                />
              </div>
              <span>Color</span>
              <br />
              <span>Asigna un color</span>
              <div className="row">
                <div className="col s2">
                  <div className="input-field">
                    <label htmlFor="color" />
                    <input
                      required
                      type="color"
                      id="color"
                      value="#2196f3"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="col s2">
                  <div className="input-field">
                    <label htmlFor="color" />
                    <input
                      required
                      type="color"
                      id="color"
                      value="#ff9800"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="col s2">
                  <div className="input-field">
                    <label htmlFor="color" />
                    <input
                      required
                      type="color"
                      id="color"
                      value="#f44336"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="col s2">
                  <div className="input-field">
                    <label htmlFor="color" />
                    <input
                      required
                      type="color"
                      id="color"
                      value="#4caf50"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="col s2">
                  <div className="input-field">
                    <label htmlFor="color" />
                    <input
                      required
                      type="color"
                      id="color"
                      value="#9c27b0"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col s5 offset-s2">
              <p>Miembros</p>
              <div className="input-field">
                <label htmlFor="content">Añadir Miembro *</label>
                <input
                  type="text"
                  id="miembros"
                  required
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>

          <br />
          <br />
          <div className="input-field center-align">
            <button
              className="btn btn-large indigo accent-4"
              onClick={this.handleSubmit}
              style={{ padding: "0 100px", margin: "0" }}
            >
              GUARDAR
            </button>
          </div>
        </form>
        <div className="container center-align">
          <button
            onClick={onCloseModal}
            className="waves-effect waves-teal btn-flat"
          >
            Cancelar
          </button>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  // console.log(state);
  return {
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createProject: project => dispatch(createProject(project))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CrearProyectoModal);
